"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    bonderFeeBps: {},
    bonderTotalStake: {},
    destinationFeeGasPriceMultiplier: 1.2,
    relayerFeeEnabled: {},
    relayerFeeWei: {},
    bridgeDeprecated: {},
    defaultSendGasLimit: {
        native: {},
        token: {}
    }
};
